import { FilterPill } from "./FilterPill";

export default FilterPill;
